export enum NotificationTableColumns {
  client = "client",
  applicationName = "applicationName",
  notificationType = "notificationType",
  createdAt = "createdAt",
  resolvedBy = "resolvedBy",
  resolvedAt = "resolvedAt",
}

export const NOTIFICATION_TABLE_COLUMN_LABELS: Record<
  NotificationTableColumns,
  string
> = {
  [NotificationTableColumns.client]: "Tenant",
  [NotificationTableColumns.applicationName]: "Application",
  [NotificationTableColumns.notificationType]: "Type",
  [NotificationTableColumns.createdAt]: "Created",
  [NotificationTableColumns.resolvedBy]: "Resolved by",
  [NotificationTableColumns.resolvedAt]: "Resolved at",
};

export const DEFAULT_ACTIVE_NOTIFICATION_TABLE_COLUMN_SETTINGS: Record<
  NotificationTableColumns,
  boolean
> = {
  [NotificationTableColumns.client]: true,
  [NotificationTableColumns.applicationName]: true,
  [NotificationTableColumns.notificationType]: true,
  [NotificationTableColumns.createdAt]: true,
  [NotificationTableColumns.resolvedBy]: false,
  [NotificationTableColumns.resolvedAt]: false,
};

export const DEFAULT_HISTORY_NOTIFICATION_TABLE_COLUMN_SETTINGS: Record<
  NotificationTableColumns,
  boolean
> = {
  [NotificationTableColumns.client]: true,
  [NotificationTableColumns.applicationName]: true,
  [NotificationTableColumns.notificationType]: true,
  [NotificationTableColumns.createdAt]: true,
  [NotificationTableColumns.resolvedBy]: true,
  [NotificationTableColumns.resolvedAt]: true,
};

export const DEFAULT_NOTIFICATION_TABLE_COLUMN_ORDER: NotificationTableColumns[] =
  [
    NotificationTableColumns.client,
    NotificationTableColumns.applicationName,
    NotificationTableColumns.notificationType,
    NotificationTableColumns.createdAt,
    NotificationTableColumns.resolvedBy,
    NotificationTableColumns.resolvedAt,
  ];

export const getColumnLabels = (): Record<string, string> =>
  NOTIFICATION_TABLE_COLUMN_LABELS;
